// A fade in the motion tokens (TF-89): a new page, a new record in its pane (TF-98). Only a fade, so it
// is kept when the system asks for less motion; nothing waits for it.
export function fadeIn(element: HTMLElement | null | undefined): void {
  if (!element?.animate) return;
  const tokens = getComputedStyle(document.documentElement);
  element.animate([{ opacity: 0 }, { opacity: 1 }], {
    duration: Number.parseFloat(tokens.getPropertyValue('--md-sys-motion-duration-short4')) || 200,
    easing: tokens.getPropertyValue('--md-sys-motion-easing-standard').trim() || 'ease',
  });
}
